<script setup lang="ts">
  import { MpTag } from '@borg/ui';
  import { Topic } from '../types';

  const props = defineProps<{
    topics?: Topic[];
  }>();

  const nonEmptyTopics = computed(() => {
    return props.topics?.filter((topic) => topic.tag && topic.tag.trim().length > 0);
  });
</script>

<template>
  <div class="article__tags">
    <LinksLocale
      v-for="(topic, idx) in nonEmptyTopics"
      :key="idx"
      :to="{ name: 'advices-search', query: { tag: topic.tag } }"
    >
      <MpTag
        class="article__tag"
        :text="`#${topic.tag}`"
        size="lg"
      />
    </LinksLocale>
  </div>
</template>

<style scoped lang="scss">
  .article {
    &__tags {
      display: flex;
      flex-wrap: wrap;
      gap: var(--mp-space-30);
    }
    &__tag {
      cursor: pointer;
    }
  }
</style>
